																																																	<template>
<div class="info">
	<div class="title">{{title||'申请人信息'}}</div>
	<Form :label-width="150" class="mt15">
	    <FormItem label="公司名称：" class="w600">
	        {{info.subjectName}}
	    </FormItem>
		<div>
			<FormItem label="统一社会信用代码：" class="w600">
				{{info.idNumber}}
			</FormItem>
		</div>
	    <FormItem label="企业所在地：" v-if="info.provinceName&&info.cityName&&info.areaName&&productCode!='PINGAN_GROUP_ACCIDENT_INSURANCE_A'&&productCode!='PINGAN_GROUP_ACCIDENT_INSURANCE_B'">
			{{info.provinceName+info.cityName+info.areaName}}
	    </FormItem>
		<FormItem label="企业地址：" class="w600">
	        {{info.address}}
	    </FormItem>
		<FormItem label="联系人：" class="w600">
	        {{info.contactName}}
	    </FormItem>
	    <FormItem label="联系电话：" class="w600">
	        {{info.contactPhone}}
	    </FormItem>
	    <FormItem label="联系人邮箱：" class="w600">
	        {{info.contactEmail}}
	    </FormItem>
		<FormItem 
			label="营业执照：" 
			class="w600">
			<div class="img">
	        	<ImageShow style="width:100px;" class="img" :url="info.bizUrl"  v-if="info.bizUrl" />
				<UploadFileImg v-if="$route.query.orderType==1&&!info.correctUrl"
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>点击上传</p>
					</div>
				</UploadFileImg>
			</div>
		</FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from './Image'
import UploadFileImg from './UploadFileImg'
export default {
	components:{ ImageShow,UploadFileImg },
	props:{
		info:Object,
		insuredList:Object,
		title:String,
		productCode:String,
		premium:Number
	},
	computed:{
	},
	methods:{
		// 上传回调方法
		uploadSuccess(val,key){
			this.info.bizUrl=val.url
		},
		delImg (index) {
			this.info.bizUrl=''
		}
	}
}
</script>
<style lang="less" scoped>
	.img{
		display:flex;
		flex-wrap:wrap;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/ApplicantInfo.vue